import { Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { CellOverlayAction } from '@shared/components/table/table-cell/actions-overlay/actions-overlay.component';
import { processBooleanValue } from '@shared/components/table/table-cell/utils';

@Component({
  selector: 'app-boolean-cell',
  imports: [TranslatePipe],
  templateUrl: './boolean-cell.component.html'
})
export class BooleanCellComponent {
  availableCellActions: CellOverlayAction[] = [];
  availableCellShiftActions: CellOverlayAction[] = ['copy_raw'];

  value = input<unknown | undefined>(undefined);

  protected processedValue = computed<boolean | undefined>(() =>
    processBooleanValue(this.value())
  );
}
